import { Reveal } from "./Reveal";
import { EXPERTS } from "../../data/content";

export default function ExpertPanel() {
  return (
    <section id="experts" data-testid="experts-section" className="bg-ov-bone py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="font-body text-xs uppercase tracking-[0.2em] font-semibold text-ov-green mb-6">
            Experts Panel
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-ov-navy leading-tight tracking-tight">
            Surveyors, architects, engineers <span className="italic text-ov-green">&amp; lawyers.</span>
          </h2>
          <p className="font-body text-ov-charcoal/70 mt-6 text-lg leading-relaxed">
            One accountable team working on your file — no fragmented advice, no blind spots.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {EXPERTS.map((e, i) => (
            <Reveal key={e.role} delay={i * 0.1}>
              <div className="group" data-testid={`expert-card-${e.role.toLowerCase()}`}>
                <div className="relative overflow-hidden rounded-2xl border border-ov-navy/10 aspect-[4/5]">
                  <img
                    src={e.img}
                    alt={e.role}
                    className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ov-navy/70 via-ov-navy/10 to-transparent" />
                  <div className="absolute bottom-5 left-5">
                    <h3 className="font-display text-2xl text-white">{e.role}</h3>
                  </div>
                </div>
                <p className="font-body text-sm text-ov-charcoal/70 mt-4 leading-relaxed">{e.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
